import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Badge, Card, CardHeader, Col, Row } from 'reactstrap';
import { MaterialIcon } from '../../../components';
import { useTranslation } from '../../../translations';
import { Fetcher, useFetcher } from '../../../utils';

export const Reservations: FC = () => {
  const { ts } = useTranslation();

  const reservations = useFetcher(async () => {
    return await api.getAllHotelReservations();
  });

  if (!reservations.data) {
    return <Fetcher result={reservations} />;
  }

  return (
    <Row>
      <Col md={12} xs={12}>
        <Card className="filter-table resultTable">
          <CardHeader>
            {reservations.data.length} {ts('common.results')}
          </CardHeader>

          {reservations.data.map((reservation) => (
            <Link
              key={reservation.id}
              style={{ color: 'inherit', textDecoration: 'inherit' }}
              to={`/housekeeping/hotel/user/${reservation.userId ?? 'TODO'}`}
            >
              <div className="table-item" id={`reservation${reservation.id}`}>
                <MaterialIcon className="icon" large name="receipt" />
                <p>{reservation.id}</p>
                <Badge color="secondary" key="status">
                  {reservation.status}
                </Badge>
              </div>
            </Link>
          ))}
        </Card>
      </Col>
    </Row>
  );
};
